module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi1-88e6f1780695c491ee556c47bede426a.webp";